import { __awaiter } from "tslib";
import { useQuery } from "@tanstack/react-query";
import { ConfigurationApi, Configuration as ConfigurationApiConfig, } from "@plansoft-configuration-renderer/configuration-api";
export function useFetchBackendTranslations(options) {
    const { basePath, localeId } = options;
    return useQuery({
        queryKey: [
            "ConfigurationApi.getStructuredTranslations",
            basePath,
            localeId,
        ],
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const api = new ConfigurationApi(new ConfigurationApiConfig({ basePath }));
            // try to load data from new api
            const data = yield api.getStructuredTranslations({
                localeId,
            });
            return data;
        }),
        refetchOnWindowFocus: false, // disable default refetch, this is very annoying in development
        refetchOnMount: false, // we mount the hook in several place. this prevents refetch on mount
        staleTime: 60 * 1000, // 1 minute
        // ⚠️do not specify initialData
    });
}
//# sourceMappingURL=useFetchBackendTranslations.js.map